var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-return-reasons" },
    [
      _c(
        "el-select",
        {
          staticClass: "item-return-reason-select",
          attrs: {
            disabled: _vm.allChecked,
            value: _vm.selectedReason,
            placeholder: "Select return reason",
            "popper-class": "item-return-reason-dropdown",
          },
          on: { change: _vm.emitSelected },
        },
        _vm._l(_vm.returnReasons, function (reason) {
          return _c(
            "el-option",
            {
              key: reason.id,
              staticClass: "item-return-reason-option",
              attrs: { label: reason.text, value: reason.id },
            },
            [
              _c("span", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(reason.text)),
              ]),
              _vm._v(" "),
              _vm.selectedReason === reason.id && _vm.showCheckMark
                ? _c("span", { staticStyle: { float: "right !important" } }, [
                    _c("img", {
                      staticStyle: {
                        height: "12.28px",
                        width: "15.78px",
                        "padding-top": "5px",
                      },
                      attrs: {
                        src: require("../../../../assets/drop-down-checkmark.svg"),
                        alt: "selected",
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }